import { setWorkspaceUsersSearchText } from '@/features/settings/settingsSlice';
import { SearchInput } from '@/global/components';
import { RootState } from '@/reducers';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const WorkspaceUsersTableSearch: FC = () => {
  const { t } = useTranslation('settings');

  return (
    <div className='flex flex-col gap-1'>
      <SearchInput
        stateSelector={(state: RootState) => state.settings.ui.workspaceUsers?.searchText || ''}
        stateUpdater={setWorkspaceUsersSearchText}
        placeholder={t('workspace.search')}
      />
    </div>
  );
};
